<div class="empty-list-container">
  <p class="label">{{ labelText | transloco }}</p>
  @if (btnText) {
    <button class="btn btn-primary" (click)="handleClick()">{{ btnText | transloco }}</button>
  }
</div>
